import {
	getAlertMessages,
	getAlertNotifications,
	changeAlertMessagesType,
	changeAlertNotificationsType,
	confirmUpdates
} from '../helpers/alertService';
import {checkError, closeAlert, receiveErrorAlert, } from './commonsActions';

/*
 * action types
 */

export const FETCH_ALERT_MSG_BEGIN   = 'FETCH_ALERT_MSG_BEGIN';
export const FETCH_ALERT_MSG_SUCCESS = 'FETCH_ALERT_MSG_SUCCESS';
export const FETCH_ALERT_MSG_ERROR = 'FETCH_ALERT_MSG_ERROR';

export const FETCH_ALERT_NOTIFY_BEGIN   = 'FETCH_ALERT_NOTIFY_BEGIN';
export const FETCH_ALERT_NOTIFY_SUCCESS = 'FETCH_ALERT_NOTIFY_SUCCESS';
export const FETCH_ALERT_NOTIFY_ERROR = 'FETCH_ALERT_NOTIFY_ERROR';

export const FETCH_NEW_ALERT_NOTIFY_BEGIN   = 'FETCH_NEW_ALERT_NOTIFY_BEGIN';
export const FETCH_NEW_ALERT_NOTIFY_SUCCESS = 'FETCH_NEW_ALERT_NOTIFY_SUCCESS';
export const FETCH_NEW_ALERT_NOTIFY_ERROR = 'FETCH_NEW_ALERT_NOTIFY_ERROR';


export const fetchAlertMessages = (query)=> dispatch => {
	dispatch({
		type: FETCH_ALERT_MSG_BEGIN
	});
	return getAlertMessages(query).then(res => {
		dispatch({
			type: FETCH_ALERT_MSG_SUCCESS,
			payload: {
				alertMessages: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_ALERT_MSG_ERROR
			})
		}, 2000);
	});
};

export const fetchAlertNotifications = (query)=> dispatch => {
	dispatch({
		type: FETCH_ALERT_NOTIFY_BEGIN
	});
	return getAlertNotifications(query).then(res => {
		dispatch({
			type: FETCH_ALERT_NOTIFY_SUCCESS,
			payload: {
				alertNotifications: res.data,
				numberOfElements : res.numberOfElements,
				totalElements: res.totalElements,
				totalPages: res.totalPages
			}
		});
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_ALERT_NOTIFY_ERROR
			})
		}, 2000);
	});
};

export const fetchNewAlertNotifications = (query)=> dispatch => {
	dispatch({
		type: FETCH_NEW_ALERT_NOTIFY_BEGIN
	});
	return getAlertNotifications({
		...query,
		type: 'NEW'
	}).then(res => {
		dispatch({
			type: FETCH_NEW_ALERT_NOTIFY_SUCCESS,
			payload: {
				totalElements: res.totalElements
			}
		});
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert('No data')); // error message
		setTimeout(() => {
			dispatch(closeAlert());
			dispatch({
				type: FETCH_NEW_ALERT_NOTIFY_ERROR
			})
		}, 2000);
	});
};

export const switchAlertMessagesType = newType => {
	return dispatch => {
		console.log(newType);
		let type = null;
		if (newType) {
			type = {
				companyId: newType.companyId,
				updatedMessageIds: newType.updatedMessageIds,
				userId: newType.userId
			};
			if (newType.mobileAppSetId) {
				type.mobileAppSetId = newType.mobileAppSetId;
			}
		}
		return changeAlertMessagesType(type).then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const switchAlertNotificationType = newType => {
	return dispatch => {
		console.log(newType);
		let type = null;
		if (newType) {
			type = {
				companyId: newType.companyId,
				notificationsInfo: newType.notificationsInfo
			};
			if (newType.mobileAppSetId) {
				type.mobileAppSetId = newType.mobileAppSetId;
			}
		}
		return changeAlertNotificationsType(type).then(res => {
			return res;
		}, error => {
			dispatch(checkError(error));
			dispatch(receiveErrorAlert(error));
			setTimeout(() => {
				dispatch(closeAlert());
			}, 2000);
		})
	};
};

export const changeUpdatesStatus = query => dispatch => {
	return confirmUpdates(query).then(res => {
		return res;
	}, error => {
		dispatch(checkError(error));
		dispatch(receiveErrorAlert(error));
		setTimeout(() => {
			dispatch(closeAlert());
		}, 2000);
	})
};



// WEBPACK FOOTER //
// ./src/actions/alertActions.js